import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { skills } from "../data/portfolio";

const easeOut = [0.22, 1, 0.36, 1];

const Column = ({ title, items, testId }) => (
  <div data-testid={testId}>
    <p className="text-xs font-bold tracking-[0.2em] uppercase text-black/50 mb-5">
      {title}
    </p>
    <ul className="space-y-2.5">
      {items.map((item) => (
        <li
          key={item}
          className="text-base lg:text-lg font-light text-black/85 leading-snug"
        >
          {item}
        </li>
      ))}
    </ul>
  </div>
);

export const Skills = () => {
  return (
    <section
      id="skills"
      className="py-24 lg:py-32 border-t border-black/10"
      data-testid="skills-section"
    >
      {/* Marquee at the top of skills */}
      <div className="border-y border-black/10 py-8 mb-20 overflow-hidden">
        <Marquee gradient={false} speed={42} pauseOnHover>
          {[...skills.tools, ...skills.tools].map((t, i) => (
            <span
              key={`${t}-${i}`}
              className="text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter mx-10 lg:mx-16 text-black/85"
            >
              {t}
              <span className="inline-block mx-6 align-middle h-2 w-2 rounded-full bg-[#FF3B30]" />
            </span>
          ))}
        </Marquee>
      </div>

      <div className="container-portfolio">
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-black/50 mb-12 lg:mb-16">
          §02 — Skills
        </p>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: easeOut }}
          className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16"
        >
          <Column title="Craft" items={skills.craft} testId="skills-craft" />
          <Column title="Tools" items={skills.tools} testId="skills-tools" />
          <Column
            title="Practice"
            items={skills.practice}
            testId="skills-practice"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
